/**
 * @fileoverview GET handler for the "/email/ip_warming/:app_group_id/required_email_templates" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdRequiredEmailTemplates } from "./constants";
import type {
  EmailIpWarmingAppGroupIdRequiredEmailTemplatesParams,
  EmailIpWarmingAppGroupIdRequiredEmailTemplatesResult,
} from "./types";
import { isEmailIpWarmingAppGroupIdRequiredEmailTemplatesResult } from "./validators";

export const getEmailIpWarmingAppGroupIdRequiredEmailTemplates = reactQueryFetcherAdapter(
  emailIpWarmingAppGroupIdRequiredEmailTemplates,
  (
    signal: AbortSignal,
    appGroupId: string,
    params: EmailIpWarmingAppGroupIdRequiredEmailTemplatesParams
  ): Promise<EmailIpWarmingAppGroupIdRequiredEmailTemplatesResult> => {
    return fetch(
      `/email/ip_warming/${appGroupId}/required_email_templates`,
      "GET",
      {
        num_of_users: params.num_of_users,
        current_volume: params.current_volume,
        target_volume: params.target_volume,
      },
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  },
  isEmailIpWarmingAppGroupIdRequiredEmailTemplatesResult
);
